import { Mail } from "lucide-react";

// The "who is this receipt for" line that sits right above a pay button. When
// we already know the buyer it is a single row; it opens into two fields only
// when something is missing or the buyer taps Change. Takes the object returned
// by hooks/usePayerDetails.
const fieldClass =
  "w-full h-11 rounded-lg border border-brand-border bg-brand-surface px-3 text-[15px] text-brand-text placeholder:text-brand-placeholder caret-brand-accent outline-none transition-[border-color,box-shadow] focus:border-brand-accent focus:shadow-[0_0_0_3px_rgba(220,38,38,0.15)] disabled:opacity-60";

export default function PayerDetails({ payer, disabled = false }) {
  if (!payer.loaded) {
    return <div className="h-11 rounded-lg bg-brand-surface2 animate-pulse" aria-hidden="true" />;
  }

  if (!payer.editing) {
    return (
      <div className="flex items-center gap-3 min-h-11">
        <Mail size={16} className="text-brand-textSecondary flex-shrink-0" aria-hidden="true" />
        <p className="flex-1 min-w-0 text-sm text-brand-textMuted truncate">
          Receipt to <span className="font-semibold text-brand-text">{payer.name}</span>
          <span className="text-brand-textSecondary"> · {payer.email}</span>
        </p>
        <button
          type="button"
          onClick={payer.startEditing}
          disabled={disabled}
          className="text-sm font-semibold text-brand-accent px-2 py-1.5 -mr-2 rounded-md hover:bg-brand-accentMuted focus-visible:outline focus-visible:outline-2 focus-visible:outline-brand-accent disabled:opacity-50"
        >
          Change
        </button>
      </div>
    );
  }

  return (
    <fieldset className="space-y-2" disabled={disabled}>
      <legend className="text-sm font-semibold text-brand-text mb-2">Where should we send your receipt?</legend>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-2">
        <label className="block">
          <span className="sr-only">Your name</span>
          <input
            type="text"
            value={payer.name}
            onChange={(e) => payer.setName(e.target.value)}
            placeholder="Your name"
            autoComplete="name"
            enterKeyHint="next"
            className={fieldClass}
          />
        </label>
        <label className="block">
          <span className="sr-only">Email</span>
          <input
            type="email"
            value={payer.email}
            onChange={(e) => payer.setEmail(e.target.value)}
            placeholder="you@example.com"
            autoComplete="email"
            inputMode="email"
            enterKeyHint="done"
            className={fieldClass}
          />
        </label>
      </div>
      {payer.error ? (
        <p className="text-sm text-brand-accent" role="alert">{payer.error}</p>
      ) : (
        <p className="text-xs text-brand-textSecondary">We'll remember these, so you only do this once.</p>
      )}
    </fieldset>
  );
}
